var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.853,
    height: 11.854,
    viewBox: "0 0 11.853 11.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10934",
    "data-name": "Group 10934",
    transform: "translate(-11.47 -26.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10815",
    "data-name": "Group 10815",
    transform: "translate(-9.482 -70.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "collapse",
    transform: "translate(21.482 97.604) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 15.263,
    transform: "translate(15.263) rotate(90)",
    fill: "none",
    stroke: "#003049",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "collapse-2",
    "data-name": "collapse",
    transform: "translate(21.482 108.396) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    y2: 15.263,
    transform: "translate(15.263) rotate(90)",
    fill: "none",
    stroke: "#003049",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.e06cb0812a412dc6f5f1be07f6fb0182.svg";
export { ForwardRef as ReactComponent };